// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BurgerMenuController from "./burger_menu_controller"
application.register("burger-menu", BurgerMenuController)

import ChoreBlueprintsController from "./chore_blueprints_controller"
application.register("chore-blueprints", ChoreBlueprintsController)

import ChoreRequestFormController from "./chore_request_form_controller"
application.register("chore-request-form", ChoreRequestFormController)

import BorrowingFormController from "./borrowing_form_controller"
application.register("borrowing-form", BorrowingFormController)

import ExpirationPresetsController from "./expiration_presets_controller"
application.register("expiration-presets", ExpirationPresetsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)

import LocaleSwitchController from "./locale_switch_controller"
application.register("locale-switch", LocaleSwitchController)

import PaycheckFormController from "./paycheck_form_controller"
application.register("paycheck-form", PaycheckFormController)
